// TODO This was taken from Lorne's styleguid. Must un-jquery it at some point.
$(document).ready(e => {
  $('.tabs li a').click(function(e) {
    $('.tabs li a').removeClass('selected');
    $(this).addClass('selected');

    const pane = $(this).attr('data-target');
    $('.tab-panes .tab-pane').each(function() {
      $(this).removeClass('active');
    });
    $(`.tab-panes .tab-pane.${pane}`).addClass('active');

    const posX = $(this).offset().left;
    const posY = $(this).offset().top;
    $('.selected span').css({
      left: e.pageX - posX - 25,
      top: e.pageY - posY - 25,
    });
  });
});
